<div class="p-2 m-2" *ngIf="allExternalConnections">

    <div *ngIf="!openForm">
        <div class="Tabletitle">
            <span class="Tabletitle"> External Connection ({{allExternalConnections.length}})</span>
        </div>
        <div class="row">
            <button class="m-1" mat-raised-button (click)="CreateExternalConn()">Create External Connection</button>
            <div class="input-group-sm mt-2 input-group col-6">
                <input *ngIf="allExternalConnections" class="form-control" type="search" (keyup)="applyFilter($event)" placeholder="Filter">
            </div>
            <!-- <mat-form-field class="element-filter" *ngIf="allExternalConnections">
                <mat-label>Filter</mat-label>
                <input matInput (keyup)="applyFilter($event)">
            </mat-form-field> -->
        </div>

        <div class="table-container mat-elevation-z8">
            <table mat-table matSort matSortActive="name" matSortDirection="asc" aria-describedby="ext-conn-table"
                [dataSource]="tableDataSource">

                <!--- Note that these columns can be defined in any order.
            The actual rendered columns are set as a property on the row definition"-->

                <!--  Name Column -->
                <ng-container matColumnDef="name">
                    <th id="name" mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
                    <td mat-cell *matCellDef="let element"> {{element.system_name}} </td>
                </ng-container>

                <!-- URL Column -->
                <ng-container matColumnDef="url">
                    <th id="event" mat-header-cell *matHeaderCellDef mat-sort-header> URL </th>
                    <td mat-cell *matCellDef="let element"> {{element.connection_url}} </td>
                </ng-container>

                <!-- Conn Column -->
                <ng-container matColumnDef="conn_Id">
                    <th id="category" mat-header-cell *matHeaderCellDef mat-sort-header> Connection ID </th>
                    <td mat-cell *matCellDef="let element">{{element.connection_parameters.id}}</td>
                </ng-container>

                <!-- Active Column -->
                <ng-container matColumnDef="active">
                    <th id="exid" mat-header-cell *matHeaderCellDef mat-sort-header> Active </th>
                    <td mat-cell *matCellDef="let element">
                        <span *ngIf="element.active">
                            <mat-icon>done</mat-icon>
                        </span>
                        <span *ngIf="!element.active">
                            <mat-icon>close</mat-icon>
                        </span>
                    </td>
                </ng-container>

                <!-- Action Column -->
                <ng-container matColumnDef="actions">
                    <th id="actions" mat-header-cell *matHeaderCellDef mat-sort-header> Actions </th>
                    <td mat-cell *matCellDef="let element">
                        <mat-icon *ngIf="element.active" title="Update External Connection"
                            (click)="updateExternalConnection(element)">edit
                        </mat-icon>
                        <mat-icon *ngIf="element.active" title="Delete External Connection"
                            (click)="deleteExternalConnection(element)">delete
                        </mat-icon>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            </table>
            <mat-paginator [pageSizeOptions]="[10, 20, 50]" [pageSize]="10" showFirstLastButtons></mat-paginator>
        </div>
    </div>


    <div *ngIf="openForm">
        <form [formGroup]="externalConnectionForm" class="card-body">
            <div class="input-group-sm mb-3 input-group col-12">
                <div class="input-group-prepend">
                    <span class="input-group-text form-label-105">Name</span>
                </div>
                <input formControlName="conn_name" class="form-control">
            </div>

            <div class="input-group-sm mb-3 input-group col-12">
                <div class="input-group-prepend">
                    <span class="input-group-text form-label-105">URL</span>
                </div>
                <input formControlName="conn_url" class="form-control">
            </div>

            <div class="input-group-sm mb-3 input-group col-12">
                <div class="input-group-prepend">
                    <span class="input-group-text form-label-105">Category</span>
                </div>
                <mat-select [(ngModel)]=categoryID (selectionChange)="getCategoryProperties(categoryID)"
                    [ngModelOptions]="{standalone: true}" (ngModelChange)="categoryID" class="form-control">
                    <mat-option>
                        <ngx-mat-select-search [(ngModel)]="searchCtrl" [placeholderLabel]="'Search...'"
                            [noEntriesFoundLabel]="'Not found'" name="search" [ngModelOptions]="{standalone: true}">
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let category of allCategories |stringFilter:searchCtrl:'name'"
                        [value]="category.id">
                        {{category.name}}
                    </mat-option>
                </mat-select>
            </div>

            <div class="card p-2 m-3 mb-2">
                <div formArrayName="param">
                <div class="form-group row">
                    <span class="form-group ml-3 float-left">Connection Parameters</span>
                    <div class="col mb-2"></div>
                </div>
                <div class="input-group-sm mb-3 input-group col-12">
                    <div class="input-group-prepend">
                        <span class="input-group-text">Authorization Type</span>
                    </div>
                    <mat-select [(ngModel)]=auth class="form-control" [ngModelOptions]="{standalone: true}">
                        <mat-option *ngFor="let authType of authorization" [value]="authType.value">
                            {{authType.name}}
                        </mat-option>
                    </mat-select>
                </div>
                <div class="input-group-sm mb-3 input-group col-12">
                    <div class="input-group-prepend">
                        <span class="input-group-text">Method</span>
                    </div>
                    <mat-select [(ngModel)]="method" class="form-control" [ngModelOptions]="{standalone: true}">
                        <mat-option *ngFor="let method of methods" [value]="method">
                            {{method}}
                        </mat-option>
                    </mat-select>
                </div>
                <div *ngIf="auth=='basicauth:cred' || auth=='basicauth:token'"
                    class="input-group-sm mb-3 input-group col-12">
                    <div class="input-group-prepend">
                        <span class="input-group-text form-label-105">Username</span>
                    </div>
                    <input class="form-control" type="text" [(ngModel)]="username"
                        [ngModelOptions]="{standalone: true}">
                </div>
                <div *ngIf="auth=='basicauth:cred' || auth=='basicauth:token'"
                    class="input-group-sm mb-3 input-group col-12">
                    <div class="input-group-prepend">
                        <span class="input-group-text form-label-105">Password</span>
                    </div>
                    <input type="password" class="form-control" [ngModelOptions]="{standalone: true}"
                        [(ngModel)]="password">
                </div>
                <div *ngIf="auth=='basicauth:token'" class="input-group-sm mb-3 input-group col-12">
                    <div class="input-group-prepend">
                        <span class="input-group-text">Authorization URL</span>
                    </div>
                    <input [ngModelOptions]="{standalone: true}" class="form-control" type="text"
                        [(ngModel)]="auth_url">
                </div>
                </div>
            </div>

            <!-- <div class="card p-2 m-3 mb-2" formArrayName="param">
                <div class="form-group row">
                    <span class="form-group ml-3 form-label-105">Parameter</span>
                    <div class="col mb-2">
                        <button mat-stroked-button class="float-right" title="Add Form" (click)="addParam()">
                            <mat-icon>add</mat-icon>Parameter
                        </button>
                    </div>
                </div>
                <div *ngFor="let section of getParam(externalConnectionForm); let i = index" [formGroupName]="i">
                    <div class="row">
                        <div class="col-11">
                            <div class="card p-2 mb-2">
                                <div class="input-group row">
                                    <div class="input-group-sm mb-3 input-group col-6">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">Name</span>
                                        </div>
                                        <input class="form-control" type="text" formControlName="name">
                                    </div>
                                    <div class="input-group-sm mb-3 input-group col-6">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">Value</span>
                                        </div>
                                        <mat-select *ngIf="this.paramArray.at(i)['controls']['dynamic'].value"
                                            formControlName="value" class="form-control">
                                            <mat-option>
                                                <ngx-mat-select-search [(ngModel)]="searchCtrl"
                                                    [placeholderLabel]="'Search...'" [noEntriesFoundLabel]="'Not found'"
                                                    name="search" [ngModelOptions]="{standalone: true}">
                                                </ngx-mat-select-search>
                                            </mat-option>
                                            <mat-option
                                                *ngFor="let property of categoryProperties |stringFilter:searchCtrl:'name'"
                                                [value]="property">
                                                {{property}}
                                            </mat-option>
                                        </mat-select>
                                        <input *ngIf="!this.paramArray.at(i)['controls']['dynamic'].value"
                                            class="form-control" type="text" formControlName="value">
                                    </div>
                                </div>

                                <div class="input-group row">
                                    <div class="input-group-sm mb-3 input-group col-6">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">Required</span>
                                        </div>
                                        <mat-slide-toggle class="pl-2 pr-2 pt-1" formControlName="required">
                                        </mat-slide-toggle>
                                    </div>
                                    <div class="input-group-sm mb-3 input-group col-6">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">Use Category Metadata</span>
                                        </div>
                                        <mat-slide-toggle class="pl-2 pr-2 pt-1" formControlName="dynamic">
                                        </mat-slide-toggle>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-1">
                            <mat-icon (click)="deleteParam(i)">delete</mat-icon>
                        </div>
                    </div>
                </div>
            </div> -->


            <div class="card p-2 m-3 mb-2">
                <div formArrayName="param">
                    <div class="form-group row">
                        <span class="form-group ml-3 form-label-105">Parameter</span>
                        <div class="col mb-2">
                            <button mat-stroked-button class="float-right" title="Add Form" (click)="addParam()">
                                <mat-icon>add</mat-icon>Parameter
                            </button>
                        </div>
                    </div>
                <div *ngFor="let section of getParam(externalConnectionForm); let i = index" [formGroupName]="i">
                  <div class="row">
                  <div class="col-11" >      
                <table
                    class="table table-bordered table-responsive-md table-striped text-center"
                    aria-describedby="search-forms">
                    <tr>
                        <th *ngFor="let column of formColumns" id="{{column}}"
                            class="table-header">
                            {{column}}
                        </th>
                    </tr>
                    <tr class="table-row">
                        <td class="col-4"><input class="form-control" type="text" formControlName="name"></td>
                        <td class="col-4"><mat-select *ngIf="this.paramArray.at(i)['controls']['dynamic'].value"
                            formControlName="value" class="form-control">
                            <mat-option>
                                <ngx-mat-select-search [(ngModel)]="searchCtrl"
                                    [placeholderLabel]="'Search...'" [noEntriesFoundLabel]="'Not found'"
                                    name="search" [ngModelOptions]="{standalone: true}">
                                </ngx-mat-select-search>
                            </mat-option>
                            <mat-option
                                *ngFor="let property of categoryProperties |stringFilter:searchCtrl:'name'"
                                [value]="property">
                                {{property}}
                            </mat-option>
                        </mat-select>
                        <input *ngIf="!this.paramArray.at(i)['controls']['dynamic'].value"
                                            class="form-control" type="text" formControlName="value"></td>
                        <td class="col-1"><mat-slide-toggle class="pl-2 pr-2 pt-1" formControlName="required">
                        </mat-slide-toggle></td>
                        <td class="col-3"><mat-slide-toggle class="pl-2 pr-2 pt-1" formControlName="dynamic">
                        </mat-slide-toggle></td>

                    </tr>
                </table>
                </div>
                    <div class="col-1">
                     <mat-icon (click)="deleteParam(i)">delete</mat-icon>
                    </div>
                </div>
                </div>
            </div>
            </div>
            <div class="card p-2 m-3 mb-2">
                <div formArrayName="body">
                    <div class="form-group row">
                        <span class="form-group ml-3 form-label-105">Body</span>
                        <div class="col mb-2">
                            <button mat-stroked-button class="float-right" title="Add Form" (click)="addBody()">
                                <mat-icon>add</mat-icon>Body
                            </button>
                        </div>
                    </div>
                <div *ngFor="let section of getBody(externalConnectionForm); let i = index" [formGroupName]="i">
                  <div class="row">
                  <div class="col-11">      
                <table
                    class="table table-bordered table-responsive-md table-striped text-center"
                    aria-describedby="search-forms">
                    <tr>
                        <th *ngFor="let column of formColumns" id="{{column}}"
                            class="table-header">
                            {{column}}
                        </th>
                    </tr>
                    <tr class="table-row">
                        <td class="col-4"><input class="form-control" type="text" formControlName="name"></td>
                        <td class="col-4"><mat-select *ngIf="this.bodyArray.at(i)['controls']['dynamic'].value"
                            formControlName="value" class="form-control">
                                <mat-option>
                                    <ngx-mat-select-search [(ngModel)]="searchCtrl"
                                        [placeholderLabel]="'Search...'" [noEntriesFoundLabel]="'Not found'"
                                        name="search" [ngModelOptions]="{standalone: true}">
                                    </ngx-mat-select-search>
                                </mat-option>
                                <mat-option
                                    *ngFor="let property of categoryProperties |stringFilter:searchCtrl:'name'"
                                    [value]="property">
                                    {{property}}
                                </mat-option>
                            </mat-select>
                            <input *ngIf="!this.bodyArray.at(i)['controls']['dynamic'].value"
                            class="form-control" type="text" formControlName="value">
                        </td>
                        <td class="col-1"><mat-slide-toggle class="pl-2 pr-2 pt-1" formControlName="required">
                        </mat-slide-toggle></td>
                        <td class="col-3"><mat-slide-toggle class="pl-2 pr-2 pt-1" formControlName="dynamic">
                        </mat-slide-toggle></td>

                    </tr>
                </table>
                </div>
                    <div class="col-1">
                     <mat-icon (click)="deleteBody(i)">delete</mat-icon>
                    </div>
                </div>
                </div>
                </div>
            </div>
            <!-- <div class="card p-2 m-3 mb-2" formArrayName="body">
                <div class="form-group row">
                    <span class="form-group ml-3 form-label-105">Body</span>
                    <div class="col mb-2">
                        <button mat-stroked-button class="float-right" title="Add Form" (click)="addBody()">
                            <mat-icon>add</mat-icon>Body
                        </button>
                    </div>
                </div>
                <div *ngFor="let section of getBody(externalConnectionForm); let i = index" [formGroupName]="i">
                    <div class="row">
                        <div class="col-11">
                            <div class="card p-2 mb-2">
                                <div class="input-group row">
                                    <div class="input-group-sm mb-3 input-group col-6">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">Name</span>
                                        </div>
                                        <input class="form-control" type="text" formControlName="name">
                                    </div>
                                    <div class="input-group-sm mb-3 input-group col-6">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">Value</span>
                                        </div>
                                        <mat-select *ngIf="this.bodyArray.at(i)['controls']['dynamic'].value"
                                            formControlName="value" class="form-control">
                                            <mat-option>
                                                <ngx-mat-select-search [(ngModel)]="searchCtrl"
                                                    [placeholderLabel]="'Search...'" [noEntriesFoundLabel]="'Not found'"
                                                    name="search" [ngModelOptions]="{standalone: true}">
                                                </ngx-mat-select-search>
                                            </mat-option>
                                            <mat-option
                                                *ngFor="let property of categoryProperties |stringFilter:searchCtrl:'name'"
                                                [value]="property">
                                                {{property}}
                                            </mat-option>
                                        </mat-select>
                                        <input *ngIf="!this.bodyArray.at(i)['controls']['dynamic'].value"
                                            class="form-control" type="text" formControlName="value">
                                    </div>
                                </div>

                                <div class="input-group row">
                                    <div class="input-group-sm mb-3 input-group col-6">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">Required</span>
                                        </div>
                                        <mat-slide-toggle class="pl-2 pr-2 pt-1" formControlName="required">
                                        </mat-slide-toggle>
                                    </div>
                                    <div class="input-group-sm mb-3 input-group col-6">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">Use Category Metadata</span>
                                        </div>
                                        <mat-slide-toggle class="pl-2 pr-2 pt-1" formControlName="dynamic">
                                        </mat-slide-toggle>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-1">
                            <mat-icon (click)="deleteBody(i)">delete</mat-icon>
                        </div>
                    </div>
                </div>
            </div> -->

            <button mat-raised-button class="backButton m-1" (click)="back()">Back</button>
            <button *ngIf="button=='Save'" mat-raised-button
                [disabled]="!externalConnectionForm.valid && !auth && !method" class="actionButton m-1"
                (click)="save()">{{button}}</button>
            <button *ngIf="button=='Update'" mat-raised-button
                [disabled]="!externalConnectionForm.valid && !auth && !method" class="actionButton m-1"
                (click)="update()">{{button}}</button>
        </form>
    </div>
</div>